import Base from "./column";

const Model = Base.extend({
  namedAttributes: {
    sequence: Number,
    checked: Boolean,
    nameOriginal: String,
  },

  defaults: {
    sequence: 0,
    checked: false,
    nameOriginal: null,
  },
});

export { Model as default };
